import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavigationHome.css";
import { FaBookOpen, FaHome, FaLayerGroup, FaMoon, FaNetworkWired, FaSun, FaUser } from "react-icons/fa";
import { SiMicrosoftazure } from "react-icons/si";
import { BsFillCloudLightningRainFill } from "react-icons/bs";
import { GiHamburgerMenu } from "react-icons/gi";
import LogoProfileCard from "../ProfileCard/LogoProfileCard";

const navItems = [
  { path: "/", label: "Home", icon: <FaHome /> },
  { path: "/content", label: "Library", icon: <FaLayerGroup /> },
  { path: "/azure", label: "Azure + AI", icon: <SiMicrosoftazure /> },
  { path: "/sharepoint", label: "Dynamics & Power Platform", icon: <FaNetworkWired /> },
  { path: "/docs", label: "Architecture Docs", icon: <FaBookOpen /> },
  { path: "/about-me", label: "Profile", icon: <FaUser /> },
];

function NavigationHome({ theme, onToggleTheme }) {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenus = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-ambient" aria-hidden="true" />

        <Link onClick={closeMenus} className="nav-logo" to="/">
          <LogoProfileCard />
          <span>
            Praveen <BsFillCloudLightningRainFill /> Tech Architecture Hub
          </span>
        </Link>

        <ul className={isMenuOpen ? "nav-menu active" : "nav-menu"}>
          {navItems.map((item) => (
            <li
              key={item.path}
              className={location.pathname === item.path ? "nav-item active" : "nav-item"}
              onClick={closeMenus}
            >
              <Link className="nav-links" to={item.path}>
                {item.icon}
                <span className="navspan">{item.label}</span>
              </Link>
            </li>
          ))}
          <li className="nav-item nav-theme-mobile" onClick={closeMenus}>
            <button
              type="button"
              className="nav-links theme-toggle-mobile"
              onClick={onToggleTheme}
              aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
            >
              {theme === "dark" ? <FaSun /> : <FaMoon />}
              <span className="navspan">{theme === "dark" ? "Light" : "Dark"}</span>
            </button>
          </li>
        </ul>

        <button
          type="button"
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
        >
          {theme === "dark" ? <FaSun /> : <FaMoon />}
          <span>{theme === "dark" ? "Light" : "Dark"}</span>
        </button>

        <button
          type="button"
          className="nav-icon"
          onClick={() => setIsMenuOpen((current) => !current)}
          aria-label="Toggle navigation"
        >
          <GiHamburgerMenu className={isMenuOpen ? "fas fa-times" : "fas fa-bars"} />
        </button>
      </div>
    </nav>
  );
}

export default NavigationHome;
